import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import {
  get_stringsy7vodl9dj0ya as get_strings,
  StringsForLanguage_English_getInstance2jm5ip12elsyk as StringsForLanguage_English_getInstance,
} from '../../strings.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { NewChildPlacementPage3k697wogz82ti as NewChildPlacementPage } from './NewChildPlacementPage.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  get_entries3kltg6n17y9pp as get_entries,
  IDknm0szoty74n as ID,
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  EndReason_Other_getInstancevgz3kb2sy6a4 as EndReason_Other_getInstance,
  ID1z61wlmtvxrjn as ID_0,
  ID1m87d1hextx54 as ID_1,
  Employer27b20p5x27kte as Employer,
  FamilyEmployerAuthorizationz43b3id5q687 as FamilyEmployerAuthorization,
  Grant2zfdfpt9q1mly as Grant,
  IDjecfjjw6mot9 as ID_2,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import {
  plus310ted5e4i90h as plus,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_activeRangedsifhrs4gcfc as get_activeRange,
  get_endInclusive2wh7ub8763o5h as get_endInclusive,
  get_endReason3vau3evhhkid6 as get_endReason,
  get_endReasonNotes2xagugicvgko8 as get_endReasonNotes,
  get__id1hi7gtah39onn as get__id,
  get__id3cxe3uvvwx5bo as get__id_0,
  get__idsxxkn2fqoor7 as get__id_1,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth,
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
  reactiveLabel206b3aonybuoa as reactiveLabel,
  maybeLabel2ow5e5yzodgn0 as maybeLabel,
} from '../components/view-utilities.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
  get_unpadded1ygmnwh0rw79t as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  IconView$_get_description_$ref_x7iif61khv8gb32hpy6 as IconView$_get_description_$ref_x7iif6,
  IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7 as IconView$_set_description_$ref_rpvc1e,
} from '../../App.mjs';
import {
  LabeledViewseav57tyecmf as LabeledView,
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  Button$_get_enabled_$ref_61t7nx58ibx9ifxb3n as Button$_get_enabled_$ref_61t7nx,
  Button$_set_enabled_$ref_o8kynzfmpduwei6tot as Button$_set_enabled_$ref_o8kynz,
} from '../applications/FamilyApplicationDetailPage.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { dialog3sxbjr735jrum as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { titleCase2ywrimcithmnb as titleCase } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/kiteui/forms/Annotations.mjs';
import { ID3lnbkn76l7dgd as ID_3 } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  listOf1jh22dvmctj1r as listOf_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { styledHeaderwng1nfqibdig as styledHeader } from '../../theme/semantics.mjs';
import {
  RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance,
  renderToStringprxvmjepz2st as renderToString,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { renderToString2kyj9dlz89tdi as renderToString_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import { ExternalLink3fl954ixvn5zt as ExternalLink } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ExternalLink.commonHtml.mjs';
import {
  _ServerFile___get_location__impl__ddyqaq3gnot90we5jhf as _ServerFile___get_location__impl__ddyqaq,
  ServerFile2veqsg2df5jtr as ServerFile,
} from '../../../../../../service-abstractions-files-client/com/lightningkite/services/files/ServerFile.mjs';
import {
  DayOfWeek_SUNDAY_getInstance2wrn9wqlq8qv4 as DayOfWeek_SUNDAY_getInstance,
  DayOfWeek_MONDAY_getInstance3u0uptycixs65 as DayOfWeek_MONDAY_getInstance,
  DayOfWeek_TUESDAY_getInstanceyj9r0qh47k6j as DayOfWeek_TUESDAY_getInstance,
  DayOfWeek_WEDNESDAY_getInstancewvb0t9y8yjce as DayOfWeek_WEDNESDAY_getInstance,
  DayOfWeek_THURSDAY_getInstance2fa72o4vitekp as DayOfWeek_THURSDAY_getInstance,
  DayOfWeek_FRIDAY_getInstance3psmv5z0rk53n as DayOfWeek_FRIDAY_getInstance,
  DayOfWeek_SATURDAY_getInstance2pwh8d7e3vqkf as DayOfWeek_SATURDAY_getInstance,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DayOfWeek.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_0,
  tablezpetcq9vbay1 as table,
} from '../components/table.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ChildPlacementDetailPage$render$lambda($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function ChildPlacementDetailPage$render$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childCopyPlacementButton_2566k1_k$();
}
function ChildPlacementDetailPage$render$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childCopyPlacementButton_2566k1_k$();
}
function ChildPlacementDetailPage$render$slambda($$this$button, this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = get_pageNavigator($$this$button.get_context_h02k06_k$());
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.placement_1;
    var tmp_0 = (yield* await_0(this_0, $completion)).child_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.placement_1;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    tmp.navigate_sm5lxf_k$(new (NewChildPlacementPage())(tmp_0, tmp$ret$1._id_1));
    return Unit_instance;
  }), 0);
}
function ChildPlacementDetailPage$render$lambda_2($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function ChildPlacementDetailPage$render$lambda_3($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementChangeEndButton_9y5npd_k$();
}
function ChildPlacementDetailPage$render$slambda$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementChangeEndButton_9y5npd_k$();
}
function ChildPlacementDetailPage$render$slambda$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementEndDateLabel_oohsnt_k$();
}
function ChildPlacementDetailPage$render$slambda$lambda$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementEndReasonLabel_2y0sr5_k$();
}
function ChildPlacementDetailPage$render$slambda$lambda$lambda_2($this$remember) {
  return plus(listOf(null), get_entries());
}
function ChildPlacementDetailPage$render$slambda$lambda$lambda_3(it) {
  var tmp1_elvis_lhs = it == null ? null : it.displayName_1;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    var tmp2_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(get_strings(AppState_getInstance()).get_state_wc71uu_k$());
    tmp = (tmp2_elvis_lhs == null ? StringsForLanguage_English_getInstance() : tmp2_elvis_lhs).get_placementEndReasonPlaceholder_rzs88g_k$();
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function ChildPlacementDetailPage$render$slambda$lambda$lambda_4($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementEndReasonNotesLabel_6gz5fa_k$();
}
function ChildPlacementDetailPage$render$slambda$lambda$lambda_5($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function ChildPlacementDetailPage$render$slambda$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function ChildPlacementDetailPage$render$slambda$lambda$lambda_6($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudSaveButton_lsaoza_k$();
}
function ChildPlacementDetailPage$render$slambda$lambda$slambda_0(this$0, $end, $reason, $notes, $close) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).get_childrenPlacement_hazabn_k$().get_6ueaa7_k$(new (ID())(this$0.id_1));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_1 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
    var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$5);
    this_1.assign_vtsfu6_k$(get_endInclusive(get_activeRange(it)), $end.get_value_j01efc_k$());
    this_1.assign_vtsfu6_k$(get_endReason(it), $reason.get_value_j01efc_k$());
    this_1.assign_vtsfu6_k$(get_endReasonNotes(it), $notes.get_value_j01efc_k$());
    var tmp$ret$1 = this_1.build_1k0s4u_k$();
    yield* tmp.modify_ff53f_k$(tmp$ret$1, $completion);
    $close();
    return Unit_instance;
  }), 1);
}
function ChildPlacementDetailPage$render$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.placement_1;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    var end = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$0.activeRange_1.endInclusive_1);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.placement_1;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    var reason = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$1.endReason_1);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.placement_1;
    var tmp$ret$2 = yield* await_0(this_2, $completion);
    var notes = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$2.endReasonNotes_1);
    var tmp = $$this$button.get_context_h02k06_k$();
    dialog(tmp, VOID, ($this$dialog, close) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_0 = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      element.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (TextView())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      element.willAddChild_hz2iwc_k$(element_0);
      element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
      element_0.invoke_bnq13k_k$(tmp_1, ChildPlacementDetailPage$render$slambda$lambda$lambda);
      element_0.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_0);
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      element.willAddChild_hz2iwc_k$(element_1);
      var tmp_2 = KMutableProperty0();
      var tmp_3 = LabeledView$_get_content_$ref_5yojet(element_1);
      var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, LabeledView$_set_content_$ref_ys1c8f(element_1));
      element_1.invoke_bnq13k_k$(tmp_4, ChildPlacementDetailPage$render$slambda$lambda$lambda_0);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
      var this_1 = themed(element_1, FieldSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (LocalDateField())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      this_1.willAddChild_hz2iwc_k$(element_2);
      element_2.bind_gesskf_k$(element_2.content_1, end);
      element_2.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element_2);
      element_1.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_1);
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_3 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
      ensureOutermostElement(element_3);
      element.willAddChild_hz2iwc_k$(element_3);
      var tmp_5 = KMutableProperty0();
      var tmp_6 = LabeledView$_get_content_$ref_5yojet(element_3);
      var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, LabeledView$_set_content_$ref_ys1c8f(element_3));
      element_3.invoke_bnq13k_k$(tmp_7, ChildPlacementDetailPage$render$slambda$lambda$lambda_1);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.select' call
      var this_2 = themed(element_3, FieldSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_4 = new (Select())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_4);
      this_2.willAddChild_hz2iwc_k$(element_4);
      var tmp_8 = remember(VOID, VOID, VOID, VOID, ChildPlacementDetailPage$render$slambda$lambda$lambda_2);
      element_4.bind_64a41i_k$(reason, tmp_8, ChildPlacementDetailPage$render$slambda$lambda$lambda_3);
      element_4.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_4);
      element_3.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_3);
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_5 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
      ensureOutermostElement(element_5);
      element.willAddChild_hz2iwc_k$(element_5);
      var tmp_9 = KMutableProperty0();
      var tmp_10 = LabeledView$_get_content_$ref_5yojet(element_5);
      var tmp_11 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, LabeledView$_set_content_$ref_ys1c8f(element_5));
      element_5.invoke_bnq13k_k$(tmp_11, ChildPlacementDetailPage$render$slambda$lambda$lambda_4);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      var this_3 = sizeConstraints(element_5, VOID, VOID, get_rem(5));
      // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
      var this_4 = themed(this_3, FieldSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_6 = new (TextArea())(this_4.get_context_h02k06_k$());
      ensureOutermostElement(element_6);
      this_4.willAddChild_hz2iwc_k$(element_6);
      element_6.bind_gesskf_k$(element_6.content_1, notes);
      element_6.onStartup_vrxh3i_k$();
      this_4.addChild_2qpft2_k$(element_6);
      element_5.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_5);
      // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_7 = new (Separator())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_7);
      element.willAddChild_hz2iwc_k$(element_7);
      element_7.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_7);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_8 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_8);
      element.willAddChild_hz2iwc_k$(element_8);
      element_8.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_5 = themed(element_8, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_9 = new (Button())(this_5.get_context_h02k06_k$());
      ensureOutermostElement(element_9);
      this_5.willAddChild_hz2iwc_k$(element_9);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_10 = new (TextView())(element_9.get_context_h02k06_k$());
      ensureOutermostElement(element_10);
      element_9.willAddChild_hz2iwc_k$(element_10);
      var tmp_12 = KMutableProperty0();
      var tmp_13 = TextView$_get_content_$ref_4pzcwl(element_10);
      var tmp_14 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb(element_10));
      element_10.invoke_bnq13k_k$(tmp_14, ChildPlacementDetailPage$render$slambda$lambda$lambda_5);
      element_10.onStartup_vrxh3i_k$();
      element_9.addChild_2qpft2_k$(element_10);
      onClick(element_9, VOID, VOID, VOID, ChildPlacementDetailPage$render$slambda$lambda$slambda(close));
      element_9.onStartup_vrxh3i_k$();
      this_5.addChild_2qpft2_k$(element_9);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      var this_6 = weight(element_8, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_11 = new (Space())(this_6.get_context_h02k06_k$());
      ensureOutermostElement(element_11);
      this_6.willAddChild_hz2iwc_k$(element_11);
      element_11.onStartup_vrxh3i_k$();
      this_6.addChild_2qpft2_k$(element_11);
      // Inline function 'com.lightningkite.kiteui.views.important' call
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      var this_7 = themed(element_8, ImportantSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_8 = themed(this_7, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_12 = new (Button())(this_8.get_context_h02k06_k$());
      ensureOutermostElement(element_12);
      this_8.willAddChild_hz2iwc_k$(element_12);
      var tmp_15 = KMutableProperty0();
      var tmp_16 = Button$_get_enabled_$ref_61t7nx(element_12);
      var tmp_17 = getPropertyCallableRef('enabled', 0, tmp_15, tmp_16, Button$_set_enabled_$ref_o8kynz(element_12));
      element_12.invoke_bnq13k_k$(tmp_17, ($this$invoke) => {
        var tmp;
        if (!($this$invoke.invoke_r7m7el_k$(end) == null) && !($this$invoke.invoke_r7m7el_k$(reason) == null)) {
          var tmp_0;
          if (!equals($this$invoke.invoke_r7m7el_k$(reason), EndReason_Other_getInstance())) {
            tmp_0 = true;
          } else {
            // Inline function 'kotlin.text.isNotBlank' call
            var this_0 = $this$invoke.invoke_r7m7el_k$(notes);
            tmp_0 = !isBlank(this_0);
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      });
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_13 = new (TextView())(element_12.get_context_h02k06_k$());
      ensureOutermostElement(element_13);
      element_12.willAddChild_hz2iwc_k$(element_13);
      var tmp_18 = KMutableProperty0();
      var tmp_19 = TextView$_get_content_$ref_4pzcwl(element_13);
      var tmp_20 = getPropertyCallableRef('content', 0, tmp_18, tmp_19, TextView$_set_content_$ref_pketfb(element_13));
      element_13.invoke_bnq13k_k$(tmp_20, ChildPlacementDetailPage$render$slambda$lambda$lambda_6);
      element_13.onStartup_vrxh3i_k$();
      element_12.addChild_2qpft2_k$(element_13);
      element_12.set_action_2ds022_k$(Action('Change end date', VOID, VOID, VOID, VOID, VOID, ChildPlacementDetailPage$render$slambda$lambda$slambda_0(this$0, end, reason, notes, close)));
      element_12.onStartup_vrxh3i_k$();
      this_8.addChild_2qpft2_k$(element_12);
      element_8.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_8);
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    return Unit_instance;
  }), 0);
}
function ChildPlacementDetailPage$render$lambda_4($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childPlacementDetailsHeading_q87f7y_k$();
}
function ChildPlacementDetailPage$render$lambda_5($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childPlacementChildLabel_g8ybd6_k$();
}
function ChildPlacementDetailPage$render$lambda_6($this$reactiveLabel) {
  return 'Child birthdate';
}
function ChildPlacementDetailPage$render$lambda_7($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childTableHeaderLocation_z6m8z_k$();
}
function ChildPlacementDetailPage$render$lambda_8($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childPlacementProviderLabel_a3mqvj_k$();
}
function ChildPlacementDetailPage$render$lambda_9($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childTableHeaderActiveDates_jvbf9l_k$();
}
function ChildPlacementDetailPage$render$lambda_10($this$maybeLabel) {
  return $this$maybeLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementEndReasonLabel_2y0sr5_k$();
}
function ChildPlacementDetailPage$render$lambda_11($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childTableHeaderAgreementStatus_cdpz04_k$();
}
function ChildPlacementDetailPage$render$lambda_12($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childPlacementAgreementLabel_a4ki58_k$();
}
function ExternalLink$_get_to_$ref_jqs3qa(p0) {
  return constructCallableReference(() => p0.get_to_kntnng_k$(), 0, 0, 174, VOID, [p0]);
}
function ExternalLink$_set_to_$ref_l7iod2(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_to_ulc74x_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 175, VOID, [p0]);
}
function ChildPlacementDetailPage$render$lambda_13($this$reactiveLabel) {
  return 'Employer authorizations';
}
function ChildPlacementDetailPage$render$lambda_14($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childPlacementGrantsLabel_lannsl_k$();
}
function ChildPlacementDetailPage$render$lambda$lambda(it) {
  return it.name_1;
}
function ChildPlacementDetailPage$render$lambda_15($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childScheduleHeading_ybonig_k$();
}
function ChildPlacementDetailPage$render$lambda_16($this$table, it) {
  return $this$table;
}
function ChildPlacementDetailPage$render$lambda_17($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childScheduleTableHeaderDay_gbtbl7_k$();
}
function ChildPlacementDetailPage$render$lambda_18($this$text, _destruct__k2r9zo) {
  var day = _destruct__k2r9zo.component1_7eebsc_k$();
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = day.name_1.toLowerCase();
  return titleCase(tmp$ret$0);
}
function ChildPlacementDetailPage$render$lambda_19($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childScheduleTableHeaderTime_8yqyxq_k$();
}
function ChildPlacementDetailPage$render$lambda_20($this$text, _destruct__k2r9zo) {
  var weekday = _destruct__k2r9zo.component2_7eebsb_k$();
  var tmp;
  if (weekday == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = $this$text.invoke_r7m7el_k$($this$text.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocationPrograms_g0oima_k$().get_6ueaa7_k$(new (ID_3())(weekday.program_1)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    tmp = tmp1_elvis_lhs == null ? $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childUnknownRateLabel_o241ct_k$() : tmp1_elvis_lhs;
  }
  var tmp1_elvis_lhs_0 = tmp;
  return tmp1_elvis_lhs_0 == null ? $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childNotScheduledLabel_mg5553_k$() : tmp1_elvis_lhs_0;
}
function ChildPlacementDetailPage$render$lambda_21($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childScheduleTableHeaderIntermittent_1zk9ks_k$();
}
function ChildPlacementDetailPage$render$lambda_22($this$text, _destruct__k2r9zo) {
  var weekday = _destruct__k2r9zo.component2_7eebsb_k$();
  var tmp1_safe_receiver = weekday == null ? null : weekday.programWhenIntermittent_1;
  var tmp;
  var tmp_0 = tmp1_safe_receiver;
  if ((tmp_0 == null ? null : new (ID_3())(tmp_0)) == null) {
    tmp = null;
  } else {
    var tmp_1 = tmp1_safe_receiver;
    // Inline function 'kotlin.let' call
    var it = (tmp_1 == null ? null : new (ID_3())(tmp_1)).raw_1;
    var tmp0_safe_receiver = $this$text.invoke_r7m7el_k$($this$text.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocationPrograms_g0oima_k$().get_6ueaa7_k$(new (ID_3())(it)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    tmp = tmp1_elvis_lhs == null ? $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childUnknownRateLabel_o241ct_k$() : tmp1_elvis_lhs;
  }
  var tmp2_elvis_lhs = tmp;
  return tmp2_elvis_lhs == null ? $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childNoLabel_jgme2o_k$() : tmp2_elvis_lhs;
}
function ChildPlacementDetailPage$render$lambda_23($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childScheduleTableHeaderTransport_xh3sc8_k$();
}
function ChildPlacementDetailPage$render$lambda_24($this$text, _destruct__k2r9zo) {
  var weekday = _destruct__k2r9zo.component2_7eebsb_k$();
  return weekday == null ? '\u2014' : $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).childTransportDescription_9po3ip_k$(weekday.transportFrom_1, weekday.transportTo_1);
}
function ChildPlacementDetailPage$render$lambda_25($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
var ChildPlacementDetailPageClass;
function ChildPlacementDetailPage() {
  if (ChildPlacementDetailPageClass === VOID) {
    class $ {
      constructor(id) {
        this.id_1 = id;
        var tmp = this;
        tmp.placement_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.awaitNotNull_2lqt5h_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_childrenPlacement_hazabn_k$().get_6ueaa7_k$(new (ID())(this.id_1))));
        var tmp_0 = this;
        tmp_0.location_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID_0())($this$remember.invoke_r7m7el_k$(this.placement_1).location_1))));
        var tmp_1 = this;
        tmp_1.provider_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$().get_6ueaa7_k$(new (ID_1())($this$remember.invoke_r7m7el_k$(this.placement_1).provider_1))));
        var tmp_2 = this;
        tmp_2.employers_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
          var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$3);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
          var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$7);
          var tmp$ret$4 = xDataClassPathInsideSet(get__id(it), $this$remember.invoke_r7m7el_k$(this.placement_1).employers_1);
          var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
        });
        var tmp_3 = this;
        tmp_3.authorizations_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_familyEmployerAuthorizations_srfp8e_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(FamilyEmployerAuthorization()), arrayOf([]), false));
          var tmp$ret$13 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$13);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(FamilyEmployerAuthorization()), arrayOf([]), false));
          var tmp$ret$17 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$17);
          var tmp$ret$14 = xDataClassPathInsideSet(get__id_0(it), $this$remember.invoke_r7m7el_k$(this.placement_1).authorizations_1);
          var tmp$ret$10 = new (Query())(tmp$ret$14, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$10));
        });
        var tmp_4 = this;
        tmp_4.grants_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_grants_dxrzz4_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Grant()), arrayOf([]), false));
          var tmp$ret$23 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$23);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Grant()), arrayOf([]), false));
          var tmp$ret$27 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$27);
          var tmp$ret$24 = xDataClassPathInsideSet(get__id_1(it), $this$remember.invoke_r7m7el_k$(this.placement_1).grants_1);
          var tmp$ret$20 = new (Query())(tmp$ret$24, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$20));
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).childPlacementDetailTitle_5imj30_k$($this$remember.invoke_r7m7el_k$(this.placement_1).childName_1));
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).childPlacementDetailTitle_5imj30_k$($this$invoke.invoke_r7m7el_k$(this.placement_1).childName_1));
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_4 = shownWhen(element_0, false, VOID, ChildPlacementDetailPage$render$lambda);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_5 = themed(this_4, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Button())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_5.willAddChild_hz2iwc_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_6 = themed(element_2, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_6.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        var this_7 = get_centered(element_3);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (IconView())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_7.willAddChild_hz2iwc_k$(element_4);
        element_4.set_source_3o5lkf_k$(Companion_getInstance_0().copy_1.resize_q1xpz0_k$(get_rem(1)));
        var tmp_2 = KMutableProperty0();
        var tmp_3 = IconView$_get_description_$ref_x7iif6(element_4);
        var tmp_4 = getPropertyCallableRef('description', 0, tmp_2, tmp_3, IconView$_set_description_$ref_rpvc1e(element_4));
        element_4.invoke_bnq13k_k$(tmp_4, ChildPlacementDetailPage$render$lambda_0);
        element_4.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_8 = get_centered(element_3);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (TextView())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_8.willAddChild_hz2iwc_k$(element_5);
        var tmp_5 = KMutableProperty0();
        var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_5);
        var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_5));
        element_5.invoke_bnq13k_k$(tmp_7, ChildPlacementDetailPage$render$lambda_1);
        element_5.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_5);
        element_3.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_3);
        onClick(element_2, VOID, VOID, VOID, ChildPlacementDetailPage$render$slambda(element_2, this));
        element_2.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_9 = shownWhen(element_0, false, VOID, ChildPlacementDetailPage$render$lambda_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_10 = themed(this_9, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (Button())(this_10.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_10.willAddChild_hz2iwc_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (TextView())(element_6.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        element_6.willAddChild_hz2iwc_k$(element_7);
        var tmp_8 = KMutableProperty0();
        var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_7);
        var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_7));
        element_7.invoke_bnq13k_k$(tmp_10, ChildPlacementDetailPage$render$lambda_3);
        element_7.onStartup_vrxh3i_k$();
        element_6.addChild_2qpft2_k$(element_7);
        onClick(element_6, VOID, VOID, VOID, ChildPlacementDetailPage$render$slambda_0(this, element_6));
        element_6.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_6);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_11 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (RowOrCol())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_11.willAddChild_hz2iwc_k$(element_8);
        element_8.set_vertical_nuap32_k$(true);
        styledHeader(element_8, ChildPlacementDetailPage$render$lambda_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (RowOrCol())(element_8.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        element_8.willAddChild_hz2iwc_k$(element_9);
        element_9.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_12 = weight(element_9, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (RowOrCol())(this_12.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_12.willAddChild_hz2iwc_k$(element_10);
        element_10.set_vertical_nuap32_k$(true);
        var tmp_11 = ChildPlacementDetailPage$render$lambda_5;
        reactiveLabel(element_10, tmp_11, ($this$reactiveLabel) => $this$reactiveLabel.invoke_r7m7el_k$(this.placement_1).childName_1);
        var tmp_12 = ChildPlacementDetailPage$render$lambda_6;
        reactiveLabel(element_10, tmp_12, ($this$reactiveLabel) => renderToString_0($this$reactiveLabel.invoke_r7m7el_k$(this.placement_1).childBirthDate_1, RenderSize_Abbreviation_getInstance()));
        var tmp_13 = ChildPlacementDetailPage$render$lambda_7;
        reactiveLabel(element_10, tmp_13, ($this$reactiveLabel) => {
          var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(this.location_1);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
          return tmp1_elvis_lhs == null ? $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childUnknownLocationLabel_r43uzs_k$() : tmp1_elvis_lhs;
        });
        var tmp_14 = ChildPlacementDetailPage$render$lambda_8;
        reactiveLabel(element_10, tmp_14, ($this$reactiveLabel) => {
          var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(this.provider_1);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
          return tmp1_elvis_lhs == null ? $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childUnknownProviderLabel_fsgzro_k$() : tmp1_elvis_lhs;
        });
        element_10.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (Separator())(element_9.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        element_9.willAddChild_hz2iwc_k$(element_11);
        element_11.onStartup_vrxh3i_k$();
        element_9.addChild_2qpft2_k$(element_11);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_13 = weight(element_9, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (RowOrCol())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        this_13.willAddChild_hz2iwc_k$(element_12);
        element_12.set_vertical_nuap32_k$(true);
        var tmp_15 = ChildPlacementDetailPage$render$lambda_9;
        reactiveLabel(element_12, tmp_15, ($this$reactiveLabel) => {
          var range = $this$reactiveLabel.invoke_r7m7el_k$(this.placement_1).activeRange_1;
          var tmp0_safe_receiver = range.endInclusive_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : renderToString_0(tmp0_safe_receiver, RenderSize_Abbreviation_getInstance());
          var end = tmp1_elvis_lhs == null ? $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childNoEndDateLabel_vluxrz_k$() : tmp1_elvis_lhs;
          return renderToString_0(range.start_1, RenderSize_Abbreviation_getInstance()) + ' \u2013 ' + end;
        });
        var tmp_16 = ChildPlacementDetailPage$render$lambda_10;
        maybeLabel(element_12, tmp_16, ($this$maybeLabel) => {
          var placement = $this$maybeLabel.invoke_r7m7el_k$(this.placement_1);
          var tmp0_safe_receiver = placement.endReason_1;
          var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.displayName_1;
          // Inline function 'kotlin.text.ifBlank' call
          var this_0 = placement.endReasonNotes_1;
          var tmp_0;
          if (isBlank(this_0)) {
            tmp_0 = null;
          } else {
            tmp_0 = this_0;
          }
          var tmp$ret$59 = tmp_0;
          return joinToString(listOfNotNull([tmp, tmp$ret$59]), ': ');
        });
        var tmp_17 = ChildPlacementDetailPage$render$lambda_11;
        reactiveLabel(element_12, tmp_17, ($this$reactiveLabel) => {
          var tmp = $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance()));
          var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(this.placement_1).signingInfo_1;
          return tmp.signatureStatusLabel_agp5cg_k$(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.status_1);
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_14 = themed(element_12, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (RowOrCol())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_14.willAddChild_hz2iwc_k$(element_13);
        element_13.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (TextView())(element_13.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        element_13.willAddChild_hz2iwc_k$(element_14);
        element_14.set_themeChoice_py59um_k$(element_14.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_18 = KMutableProperty0();
        var tmp_19 = TextView$_get_content_$ref_4pzcwl(element_14);
        var tmp_20 = getPropertyCallableRef('content', 0, tmp_18, tmp_19, TextView$_set_content_$ref_pketfb(element_14));
        element_14.invoke_bnq13k_k$(tmp_20, ChildPlacementDetailPage$render$lambda_12);
        element_14.onStartup_vrxh3i_k$();
        element_13.addChild_2qpft2_k$(element_14);
        // Inline function 'com.lightningkite.kiteui.views.direct.externalLink' call
        var this_15 = get_unpadded(element_13);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (ExternalLink())(this_15.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        this_15.willAddChild_hz2iwc_k$(element_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (TextView())(element_15.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        element_15.willAddChild_hz2iwc_k$(element_16);
        var tmp_21 = KMutableProperty0();
        var tmp_22 = TextView$_get_content_$ref_4pzcwl(element_16);
        var tmp_23 = getPropertyCallableRef('content', 0, tmp_21, tmp_22, TextView$_set_content_$ref_pketfb(element_16));
        element_16.invoke_bnq13k_k$(tmp_23, ($this$invoke) => {
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(this.placement_1).signedDocument_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.at_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : renderToString(tmp1_safe_receiver, RenderSize_Abbreviation_getInstance());
          return tmp2_elvis_lhs == null ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childPlacementAgreementNoneSet_y46u4u_k$() : tmp2_elvis_lhs;
        });
        element_16.onStartup_vrxh3i_k$();
        element_15.addChild_2qpft2_k$(element_16);
        var tmp_24 = KMutableProperty0();
        var tmp_25 = ExternalLink$_get_to_$ref_jqs3qa(element_15);
        var tmp_26 = getPropertyCallableRef('to', 0, tmp_24, tmp_25, ExternalLink$_set_to_$ref_l7iod2(element_15));
        element_15.invoke_bnq13k_k$(tmp_26, ($this$invoke) => {
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(this.placement_1).signedDocument_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.file_1;
          var tmp;
          var tmp_0 = tmp1_safe_receiver;
          if ((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = _ServerFile___get_location__impl__ddyqaq(tmp1_safe_receiver);
          }
          return tmp;
        });
        element_15.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_15);
        element_13.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_13);
        element_12.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_12);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (Separator())(element_9.get_context_h02k06_k$());
        ensureOutermostElement(element_17);
        element_9.willAddChild_hz2iwc_k$(element_17);
        element_17.onStartup_vrxh3i_k$();
        element_9.addChild_2qpft2_k$(element_17);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_16 = weight(element_9, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_18 = new (RowOrCol())(this_16.get_context_h02k06_k$());
        ensureOutermostElement(element_18);
        this_16.willAddChild_hz2iwc_k$(element_18);
        element_18.set_vertical_nuap32_k$(true);
        var tmp_27 = shownWhen(element_18, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.let' call
          var it = $this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull());
          return $this$shownWhen.invoke_r7m7el_k$(it.isAdmin_1) || $this$shownWhen.invoke_r7m7el_k$(it.managedFamilies_1).contains_aljjnj_k$(new (ID_2())($this$shownWhen.invoke_r7m7el_k$(this.placement_1).family_1));
        });
        var tmp_28 = ChildPlacementDetailPage$render$lambda_13;
        reactiveLabel(tmp_27, tmp_28, ($this$reactiveLabel) => {
          var tmp = $this$reactiveLabel.invoke_r7m7el_k$(this.authorizations_1);
          // Inline function 'kotlin.text.ifBlank' call
          var this_0 = joinToString(tmp, ', ', VOID, VOID, VOID, VOID, (authorization) => {
            // Inline function 'kotlin.collections.find' call
            var tmp0 = $this$reactiveLabel.invoke_r7m7el_k$(this.employers_1);
            var tmp$ret$87;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s.next_20eer_k$();
                if (equals(element._id_1, authorization.employer_1)) {
                  tmp$ret$87 = element;
                  break $l$block;
                }
              }
              tmp$ret$87 = null;
            }
            var tmp0_safe_receiver = tmp$ret$87;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
            var employer = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
            var start = renderToString_0(authorization.activeRange_1.start_1, RenderSize_Abbreviation_getInstance());
            var end = renderToString_0(authorization.activeRange_1.endInclusive_1, RenderSize_Abbreviation_getInstance());
            return employer + ' (' + start + ' \u2013 ' + end + ')';
          });
          var tmp_0;
          if (isBlank(this_0)) {
            tmp_0 = '[Not set]';
          } else {
            tmp_0 = this_0;
          }
          return tmp_0;
        });
        var tmp_29 = ChildPlacementDetailPage$render$lambda_14;
        reactiveLabel(element_18, tmp_29, ($this$reactiveLabel) => {
          var tmp = $this$reactiveLabel.invoke_r7m7el_k$(this.grants_1);
          // Inline function 'kotlin.text.ifBlank' call
          var this_0 = joinToString(tmp, ', ', VOID, VOID, VOID, VOID, ChildPlacementDetailPage$render$lambda$lambda);
          var tmp_0;
          if (isBlank(this_0)) {
            tmp_0 = '[None set]';
          } else {
            tmp_0 = this_0;
          }
          return tmp_0;
        });
        element_18.onStartup_vrxh3i_k$();
        this_16.addChild_2qpft2_k$(element_18);
        element_9.onStartup_vrxh3i_k$();
        element_8.addChild_2qpft2_k$(element_9);
        element_8.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_19 = new (Space())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_19);
        element.willAddChild_hz2iwc_k$(element_19);
        element_19.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_19);
        styledHeader(element, ChildPlacementDetailPage$render$lambda_15);
        var tmp_30 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = listOf_0([DayOfWeek_SUNDAY_getInstance(), DayOfWeek_MONDAY_getInstance(), DayOfWeek_TUESDAY_getInstance(), DayOfWeek_WEDNESDAY_getInstance(), DayOfWeek_THURSDAY_getInstance(), DayOfWeek_FRIDAY_getInstance(), DayOfWeek_SATURDAY_getInstance()]);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$98 = to(item, $this$remember.invoke_r7m7el_k$(this.placement_1).schedule_1.get_riprg6_k$(item));
            destination.add_utx5q5_k$(tmp$ret$98);
          }
          return destination;
        });
        var tmp_31 = ChildPlacementDetailPage$render$lambda_16;
        var tmp_32 = Companion_instance_0;
        var tmp_33 = ChildPlacementDetailPage$render$lambda_17;
        var tmp_34 = tmp_32.text$default_gwb2zv_k$(tmp_33, VOID, ChildPlacementDetailPage$render$lambda_18);
        var tmp_35 = Companion_instance_0;
        var tmp_36 = ChildPlacementDetailPage$render$lambda_19;
        var tmp_37 = tmp_35.text$default_gwb2zv_k$(tmp_36, VOID, ChildPlacementDetailPage$render$lambda_20);
        var tmp_38 = Companion_instance_0;
        var tmp_39 = ChildPlacementDetailPage$render$lambda_21;
        var tmp_40 = tmp_38.text$default_gwb2zv_k$(tmp_39, VOID, ChildPlacementDetailPage$render$lambda_22);
        var tmp_41 = Companion_instance_0;
        var tmp_42 = ChildPlacementDetailPage$render$lambda_23;
        table(element, tmp_30, tmp_31, [tmp_34, tmp_37, tmp_40, tmp_41.text$default_gwb2zv_k$(tmp_42, VOID, ChildPlacementDetailPage$render$lambda_24)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_17 = shownWhen(element, VOID, VOID, ChildPlacementDetailPage$render$lambda_25);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (Space())(this_17.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_20);
        this_17.willAddChild_hz2iwc_k$(element_20);
        element_20.onStartup_vrxh3i_k$();
        this_17.addChild_2qpft2_k$(element_20);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'ChildPlacementDetailPage', VOID, VOID, [Page()]);
    ChildPlacementDetailPageClass = $;
  }
  return ChildPlacementDetailPageClass;
}
//region block: exports
export {
  ChildPlacementDetailPage as ChildPlacementDetailPagewfmc55i6s15v,
};
//endregion

//# sourceMappingURL=ChildPlacementDetailPage.mjs.map
